export enum AdStatus {
  Pending = 'PENDING',
  Published = 'APPROVED',
  Rejected = 'REJECTED',
  Expired = 'EXPIRED',
  AwaitingPayment = 'AWAITING_PAYMENT',
}

export interface SelectOption {
  label: string;
  value: string;
  dataStat?: string;
}
